import { useQuery } from '@tanstack/react-query';
// eslint-disable-next-line no-restricted-imports -- own-row profiles read (RLS); moves to Hono with the settings-pages debt, together with Profile.tsx's writes
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

/** One shape for every reader of the signed-in user's `profiles` row. */
const CURRENT_PROFILE_COLUMNS =
  'user_id, display_name, email, created_at, last_synced_at, default_landing_page, analytics_opt_out';

export const currentProfileQueryKey = (userId: string | undefined) => ['userProfile', userId] as const;

/**
 * The signed-in user's profile (header avatar, /profile, org select, and the
 * analytics identity/opt-out). The only owner of the `['userProfile', id]`
 * cache key — writers update it through `currentProfileQueryKey`.
 */
export function useCurrentProfile() {
  const { user } = useAuth();
  return useQuery({
    queryKey: currentProfileQueryKey(user?.id),
    queryFn: async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select(CURRENT_PROFILE_COLUMNS)
        .eq('user_id', user!.id)
        .single();
      if (error) throw error;
      return data;
    },
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
  });
}
